export default class MenuService
{
    constructor(http) {
        this.http = http
    }

    async employeeMenu()
    {
        const endpoint = '/menu'
        const { data } = await this.http.get(endpoint)

        return data.collection
    }

    async topMenu()
    {
        const endpoint = '/categories'
        const filters = JSON.stringify([
            {property: 'sites__slug', value: 'intranet', stage: 1000}
        ])
        const params = { filters }
        const { data } = await this.http.get(endpoint, { params })

        return data.collection
    }

    async subMenuPages(area) {
        const endpoint = '/categories'
        const filters = JSON.stringify([
            { property: 'sites__slug', value: area, stage: 1001 }
        ])

        const params = { filters }
        
        const { data } = await this.http.get(endpoint, { params })

        return data.collection
    }

    async subArea(area) {
        const endpoint = '/area'

        const filters = JSON.stringify([
            { property: 'slug', value: area, stage: 1001 }
        ])

        const params = { filters }
        
        const { data } = await this.http.get(endpoint, { params })

        return data.collection
    }
}